import { useMutation, useQueryClient } from '@tanstack/react-query';
import CaregiverService, { type ICaregiver } from '../../services/CaregiverService.ts';

export function useCaregiversPageMutations() {
  const queryClient = useQueryClient();

  const invalidateCaregivers = async () => {
    await queryClient.invalidateQueries({ queryKey: ['caregivers'] });
  };

  const updateCaregiverStatusMutation = useMutation({
    mutationFn: (variables: { caregiver: ICaregiver; isActive: boolean }) =>
      CaregiverService.updateCaregiverStatus(variables.caregiver.id, {
        is_active: variables.isActive,
      }),
    onSuccess: async () => {
      await invalidateCaregivers();
    },
  });

  return {
    updateCaregiverStatusMutation,
    invalidateCaregivers,
    isCrudLoading: updateCaregiverStatusMutation.isPending,
  };
}

